module.exports = __webpack_public_path__ + "media/integrations/amazon-105181b0.svg";